'use client'

import { stripe } from '@/lib/stripe'
import { useRouter } from 'nextjs-toploader/app'

export default function StripeConnectButton({ customTrigger }) {
  const router = useRouter()
  async function getAccountLink(accountId) {
    return await stripe.accountLinks.create({
      account: accountId,
      refresh_url: `${process.env.NEXT_PUBLIC_BASE_URL}/account/connect-account/stripe/refresh?accountId=${accountId}&callbackUrl=${window.location.href}`,
      return_url: `${process.env.NEXT_PUBLIC_BASE_URL}/account/connect-account/stripe/return?accountId=${accountId}&callbackUrl=${window.location.href}`,
      type: 'account_onboarding',
    })
  }

  async function createStripeAccount() {
    const account = await stripe.accounts.create({
      type: 'standard',
    })

    const accountLink = await getAccountLink(account.id)

    router.push(accountLink.url)
  }

  return (
    <button onClick={createStripeAccount}>{customTrigger || 'Connect'}</button>
  )
}
